import * as React from 'react';
import { TAboutUs } from './AboutUs.types';
import { BreadcrumbsBlock } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { ABOUT_US_CARD_KEYS } from './AboutUs.constants';
import './AboutUs.styled.scss';

export const AboutUs: TAboutUs = () => {
  const localize = useLocalize();

  return (
    <section className="about-us">
      <div className="about-us__container">
        <div className="about-us__content">
          <BreadcrumbsBlock />
          <div className="about-us__surface">
            <h3 className="about-us__title">
              {localize('about.us.page.title')}
            </h3>
            <p className="about-us__subtitle body2">
              {localize('about.us.page.subtitle')}
            </p>
            <p className="about-us__description body1">
              {localize('about.us.page.description')}
            </p>
            <div className="about-us__cards">
              {ABOUT_US_CARD_KEYS.map((cardKey) => (
                <article key={cardKey} className="about-us__card">
                  <h5 className="about-us__card-title">
                    {localize(`about.us.page.card.${cardKey}.title`)}
                  </h5>
                  <p className="about-us__card-text body1">
                    {localize(`about.us.page.card.${cardKey}.text`)}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
